export const PACKAGE_NAME = 'COMMON'
export enum LocaleType {
  ZH_CN = 'zh_cn',
  EN_US = 'en_us'
}